module.exports = __webpack_public_path__ + "img/iressLogo.f51d7386.png";